import event, {EVENTS} from '../../lib/event';
import Audio from '../../lib/audio';
import Cartoon from '../avatar-action';
import showMsg from './show-msg';

/**
 * 弹出提示信息
 * @param {string} title - 标题，可选
 * @param {string} msg - 提示文字
 * @returns {promise} 取消按钮 reject、确定按钮 resolve
 */
export default function aoTalk({title, msg}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return showMsg({title, msg}, mode, _index);
    /*
    return new Promise((resolve, reject) => {
        event.once(EVENTS.STEP_ABORT, () => {
            reject('Step Abort');
        });
        Cartoon.speakText(msg, title)

        event.on('CANCEL_GUIDE', () => {
            reject('点了取消按钮');
        });
        event.on('NEXT_GUIDE', () => {
            resolve(true);
        });
    });

     */
}
